import React from "react";
import styles from "./cssmodules/MinimalInteractions.module.css";

import { WifiOff, Wifi } from "@mui/icons-material";

const NetworkStatus = ({ isOnline, showRestoredMessage }) => {
  return (
    <>
      {!isOnline ? (
        <div className={styles.network_status_error_container}>
            <div className={styles.network_status_message}><span><WifiOff /></span> You're offline. Check your connection</div>
        </div>
      ) : (
        showRestoredMessage && (
          <div className={styles.network_status_restored_container}>
            <div className={styles.network_status_message}><span><Wifi /></span> Connection restored. you're online again</div>
          </div>
        )
      )}
    </>
  );
};

export default NetworkStatus;
